<template>
  <main>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t('title.listServices') }} ({{ total }})</h3>
            </template>

            <template v-slot:right-element>
              <router-link
                :to="{ name: 'AddService' }"
                class="btn button btn-primary"
                :disabled="loading"
              >
                <i class="icon-Add"></i>
                {{ $t('button.addService') }}
              </router-link>
            </template>
          </TopTemplate>
        </div>
      </div>
    </div>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container-fluid empty-message">
      <div class="col-md-12">
        <div v-if="!loading && services.length == 0" class="card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearshService") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading && services.length > 0">
      <div class="table list_service">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper table-responsive-vertical table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th class="col-md-2">
                        {{$t('service.tab.status')}}
                        <div class="icon-wrapper" @click="sortB('is_active')">
                          <i
                            class="ri-arrow-up-s-line"
                            :class="[specTri('is_active', true)]"
                          />
                          <i
                            class="ri-arrow-down-s-line"
                            :class="[specTri('is_active', false)]"
                          />
                        </div>
                        <!-- <span><i class="ri-arrow-up-s-line"></i>
                          <i class="ri-arrow-down-s-line"></i></span>-->
                      </th>
                      <th class="col-md-2">
                        {{ $t('service.tab.type') }}
                        <div class="icon-wrapper" @click="sortB('name')">
                          <i
                            class="ri-arrow-up-s-line"
                            :class="[specTri('name', true)]"
                          />
                          <i
                            class="ri-arrow-down-s-line"
                            :class="[specTri('name', false)]"
                          />
                        </div>
                        <!-- <span><i class="ri-arrow-up-s-line"></i>
                          <i class="ri-arrow-down-s-line"></i></span>-->
                      </th>
                      <th class="col-md-5">
                        {{ $t('service.description') }}
                        <div class="icon-wrapper" @click="sortB('created_at')">
                          <i
                            class="ri-arrow-up-s-line"
                            :class="[specTri('created_at', true)]"
                          />
                          <i
                            class="ri-arrow-down-s-line"
                            :class="[specTri('created_at', false)]"
                          />
                        </div>
                      </th>
                      <th
                      class="col-md-2"
                      >
                        {{ $t('service.price') }}
                        <div class="icon-wrapper" @click="sortB('price')">
                          <i
                            class="ri-arrow-up-s-line"
                            :class="[specTri('price', true)]"
                          />
                          <i
                            class="ri-arrow-down-s-line"
                            :class="[specTri('price', false)]"
                          />
                        </div>
                      </th>
                      <th class="col-md-2">{{ $t('common.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="service in services" :key="service.id">
                      <td class="col-md-2">
                        <label v-if="service.is_active == 1 || service.name === 'Inscription'" class="switch">
                          <input type="checkbox" checked @click="changeStatus(service.id)"/>
                          <span class="slider round"></span>
                        </label>

                        
                        <label v-else class="switch">
                          <input type="checkbox" @click="changeStatus(service.id)"/>
                          <span class="slider round"></span>
                        </label>
                      </td>
                      <td class="col-md-2">
                        <router-link
                          :to="{
                            name: 'DetailsService',
                            params: { id: service.id },
                          }"
                          class
                          ><span>{{ service.name }}</span>
                        </router-link>
                      </td>
                      <td class="col-md-5">
                       {{ service.description }}
                      </td>
                      <td class="col-md-2 centerPrice">
                        <span v-if="service.price === 0">--</span
                        ><span v-else>{{ service.price.price }}</span>
                      </td>
                      <td class="col-md-2">
                        <div class="espace_height">
                        <router-link
                          :to="{
                            name: 'DetailsService',
                            params: { id: service.id },
                          }"
                          class
                        >
                          <i class="icon-eyes">
                            <span class="tooltiptext">{{ $t('button.tooltip.details') }}</span>
                          </i>
                        </router-link>
                        <router-link
                          :to="{
                            name: 'EditService',
                            params: { id: service.id },
                          }"
                          class
                        >
                          <i class="icon-edit-02">
                            <span class="tooltiptext">{{ $t('button.tooltip.update') }}</span>
                          </i>
                        </router-link>
                      </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="table__wrapper__pagination-wrapper">
                  <div class="pagination">
                    <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
  
  <script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import ServicesService from "../../services/services.service";
import pagination from "../../components/navigation/Pagination";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import _ from "lodash";

export default {
  name: "ListService",
  components: {
    TopTemplate,
    pagination,
    Datepicker,
  },
 
  data() {
    return {
      pagination: {},
      total: 0,
      last_page : null,
      datede: null,
      datea: null,
      loading: false,
      params: {
        q: "",
        limit: 7,
        page: 1,
        sort: "created_at",
        order: false,
      },

      services: [],
      selected: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListServices();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListServices();
    },

    ListServices() {
      this.loading = true;
      ServicesService.getAll({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
        },
      }).then(
        (response) => {
          this.services = response.data.data;
          this.services.forEach((element) => {
            if (element.price === null) {
              element.price = 0;
            }
          });
          this.pagination = this.makePagination(
            response.data.meta,
            response.data.links
          );
          this.total = response.data.meta.total;
          this.loading = false;
        }
      ).catch((error) => {
        this.loading = false;
           if (error.response && error.response.status === 403) {
              this.$router.push('/error-403');
            }
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    getResults(page = null) {
      this.selected = [];
      this.params.page = !page ? this.params.page : page;
      this.loading = true;

      ServicesService.getAll({
        params: {
          limit: this.params.limit,
          page: this.params.page,
        },
      }).then(
        (response) => {
          this.services = response.data.data;

          this.pagination = this.makePagination(
            response.data.meta,
            response.data.links
          );
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
          this.loading = false;
        }
      ).catch((error) => {
        
      }
    ).finally(()=>{this.loading = false;});
    },
    changeStatus(id){
      ServicesService.updateStatus(id);
     // this.getResults()
    }
  },
  mounted() {
    this.ListServices();
  },
};
</script>